window.onload = function () {
    // Function to show/hide content based on the language.
    function showHideContentBasedOnLanguage(language) {
      var contentFr = document.getElementById("content-fr");
      var contentEn = document.getElementById("content-en");

      if (contentFr && contentEn) {
        if (language === "fr") {
          contentFr.style.display = "block";
          contentEn.style.display = "none";
        } else {
          contentFr.style.display = "none";
          contentEn.style.display = "block";
        }

        console.log("Language changed to:", language);
        console.log("contentFr:", contentFr.style.display);
        console.log("contentEn:", contentEn.style.display);
      }
    }

    // Function to be called when the lang attribute changes.
    function handleLanguageChange(mutationsList) {
      for (var mutation of mutationsList) {
        if (mutation.type === "attributes" && mutation.attributeName === "lang") {
          var language = mutation.target.getAttribute("lang");
          showHideContentBasedOnLanguage(language);
        }
      }
    }

    // Get the <html> element.
    var htmlElement = document.querySelector("html");

    // Initially, call the function to check and show/hide content based on the detected language.
    var initialLanguage = htmlElement.getAttribute("lang");
    showHideContentBasedOnLanguage(initialLanguage);

    // Create a new MutationObserver and attach it to the <html> element.
    var observer = new MutationObserver(handleLanguageChange);
    observer.observe(htmlElement, { attributes: true });
  };